// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".new-background[data-v-e46194a6]{background-color:#151545}.v-list[data-v-e46194a6]{max-height:75vh;overflow-y:auto}", ""]);
// Exports
module.exports = exports;
